import { _useEventDispatch, _useOnEvent } from './EventEmitter.hooks'

export const useEventDispatch = _useEventDispatch
export const useOnEvent = _useOnEvent
